import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { ChevronRight, Shield, ShieldCheck } from "lucide-react";
import { C, fadeUp, stagger, trustLogos } from "./data";

export const Hero = ({ navigate }) => (
  <>
    {/* HERO */}
    <section className="relative pt-44 pb-28 px-6 overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0" style={{ background: `radial-gradient(ellipse at 50% 0%, rgba(0,109,67,0.04) 0%, transparent 60%)` }} />
      </div>

      <motion.div className="relative z-10 max-w-6xl mx-auto" initial="hidden" animate="visible" variants={stagger}>
        <motion.div variants={fadeUp} custom={0} className="flex items-center gap-2 mb-8">
          <span className="px-3 py-1 rounded-full text-xs font-mono" style={{ background: C.greenDim, border: `1px solid ${C.greenBorder}`, color: C.green }}>
            31-Tool Security Framework
          </span>
        </motion.div>

        <motion.h1 variants={fadeUp} custom={1} className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.05] mb-8 max-w-4xl" style={{ color: C.text1 }} data-testid="hero-heading">
          Audit-Ready Cloud Architecture<span style={{ color: C.green }}>.</span>
          <br />
          <span style={{ color: C.text3 }}>Shipped in Minutes<span style={{ color: C.green }}>.</span></span>
        </motion.h1>

        <motion.div variants={fadeUp} custom={2} className="flex flex-col md:flex-row gap-12 mb-12">
          <p className="text-lg leading-relaxed max-w-xl" style={{ color: C.text3 }}>
            Production IaC validated by <span className="font-semibold" style={{ color: C.green }}>Checkov</span>, <span className="font-semibold" style={{ color: C.green }}>tfsec</span>, <span className="font-semibold" style={{ color: C.green }}>Trivy</span>, and <span className="font-semibold" style={{ color: C.green }}>Prowler</span> before export. Self-healing engine auto-remediates violations. Zero secrets. 100% encryption.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} custom={3} className="flex flex-wrap items-center gap-4">
          <Button size="lg" className="font-semibold px-8 py-6 rounded-md text-base" style={{ background: C.dark, color: C.darkText1 }}
            onClick={() => navigate('/wizard')} data-testid="hero-cta-btn"
          >
            Start Building <ChevronRight className="w-5 h-5 ml-1" />
          </Button>
          <Button size="lg" variant="outline" className="px-8 py-6 rounded-md text-base font-medium" style={{ borderColor: C.border, color: C.text2 }}
            onMouseEnter={e => e.currentTarget.style.borderColor = C.borderHover}
            onMouseLeave={e => e.currentTarget.style.borderColor = C.border}
            onClick={() => navigate('/demo')} data-testid="hero-demo-btn"
          >
            See it in action
          </Button>
        </motion.div>

        <motion.div variants={fadeUp} custom={4} className="flex flex-wrap items-center gap-3 mt-12">
          {["SOC 2 Type II", "ISO 27001", "HIPAA", "PCI-DSS"].map((badge) => (
            <span key={badge} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-mono" style={{ background: C.greenDim, border: `1px solid ${C.greenBorder}`, color: C.green }} data-testid={`hero-badge-${badge.toLowerCase().replace(/\s+/g, '-')}`}>
              <ShieldCheck className="w-3 h-3" />{badge}
            </span>
          ))}
        </motion.div>
      </motion.div>
    </section>

    {/* TRUST BAR */}
    <section className="py-8" style={{ borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, background: C.surface }} data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs font-mono tracking-widest uppercase mb-5" style={{ color: C.text4 }}>Trusted by teams shipping to</p>
        <Marquee gradient={false} speed={35} pauseOnHover>
          {[...trustLogos, ...trustLogos].map((logo, i) => (
            <div key={i} className="mx-8 flex items-center gap-2 opacity-50 hover:opacity-100 transition-opacity duration-300 cursor-default">
              <Shield className="w-4 h-4" style={{ color: '#00E5FF' }} />
              <span className="text-sm font-medium tracking-wide" style={{ color: '#00E5FF' }}>{logo}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  </>
);
